import { render, staticRenderFns } from "./AllDeliveries.vue?vue&type=template&id=d0271628&scoped=true"
import script from "./AllDeliveries.vue?vue&type=script&lang=js"
export * from "./AllDeliveries.vue?vue&type=script&lang=js"
import style0 from "./AllDeliveries.vue?vue&type=style&index=0&id=d0271628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0271628",
  null
  
)

export default component.exports